module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title-2"
  }, [_c('span', [_vm._v("A DAY AT THE BANK")])]), _vm._v(" "), _c('p', {
    staticClass: "blq-normal1"
  }, [_vm._v("An organized money market has many advantages. But it is not a school of social ethics or political responsibility.")]), _vm._v(" "), _c('p', {
    staticClass: "rightb"
  }, [_c('span', [_c('span', [_vm._v("—"), _c('i', [_vm._v("R. H. Tawney")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab5e9a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter004.vue
// module id = 87
// module chunks = 0